<template>
  <div class="policy-page">
    <h1 class="page-title">プライバシーポリシー</h1>

    <section class="policy-section">
      <h2 class="section-title">1. 個人情報の利用目的</h2>
      <p>
        当サイトでは、お問い合わせの際にご入力いただいた氏名・メールアドレス等の個人情報を、
        お問い合わせへの回答や必要な情報提供のために利用いたします。<br />
        これらの情報は上記目的以外では利用いたしません。
      </p>
    </section>

    <section class="policy-section">
      <h2 class="section-title">2. Cookie（クッキー）の利用について</h2>
      <p>
        当サイトでは、利便性向上やアクセス解析、広告配信の最適化を目的としてCookieを使用しています。<br />
        Cookieには個人を特定できる情報は含まれておらず、ユーザーはブラウザの設定によりCookieを無効化することが可能です。<br /><br />
        また、当サイトでは第三者配信の広告サービス（Google広告、各ASPなど）を利用しており、
        広告配信事業者もCookieを利用してユーザーの興味に基づいた広告を表示する場合があります。
      </p>
    </section>

    <section class="policy-section">
      <h2 class="section-title">3. アクセス解析ツールについて</h2>
      <p>
        当サイトでは、Googleが提供するアクセス解析ツール「Google Analytics」を利用しています。<br />
        Google AnalyticsはCookieを使用して匿名のトラフィックデータを収集しており、
        個人を特定するものではありません。詳細についてはGoogleのプライバシーポリシーをご確認ください。
      </p>
    </section>

    <section class="policy-section">
      <h2 class="section-title">4. 広告配信について</h2>
      <p>
        当サイトは、第三者配信の広告サービスを利用する場合があり、ユーザーの興味に応じた広告を表示します。<br />
        これらの広告配信事業者は、ユーザーのアクセス情報に基づいて広告を配信することがあります。
      </p>
    </section>

    <section class="policy-section">
      <h2 class="section-title">5. 免責事項</h2>
      <p>
        当サイトに掲載しているコンテンツや情報は正確性の確保に努めておりますが、正確性や完全性を保証するものではありません。<br />
        当サイトの利用によって生じたいかなる損害についても、当サイト運営者は責任を負いません。
      </p>
    </section>

    <section class="policy-section">
      <h2 class="section-title">6. プライバシーポリシーの変更</h2>
      <p>
        本ポリシーの内容は、法令の変更その他の理由により、予告なく改定される場合があります。<br />
        重要な変更がある場合は、当サイト上にて速やかに告知いたします。
      </p>
    </section>
  </div>
</template>

<script setup>
</script>

<style scoped>
.policy-page {
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
  line-height: 1.8;
  color: #2c3e50;
  text-align: left;
  margin-top: 0;
}

.page-title {
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
  border-bottom: 3px solid #3f51b5;
  padding-bottom: 5px;
  padding-top: 30px;
  margin-top: 0;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 12px;
  color: #3f51b5;
  border-left: 4px solid #3f51b5;
  padding-left: 8px;
}

.policy-section {
  margin-bottom: 40px;
}

/* === スマホ調整 === */
@media (max-width: 600px) {
  p {
    font-size: 1rem;
  }

  .info-table {
    font-size: 1rem;
  }

  .section-title {
    font-size: 1.2rem;
  }

  .page-title {
    font-size: 1.6rem
  }
}
</style>
